var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushNotificationsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 10.1665V11.5833C16.6665 14.2083 15.1665 15.3333 12.9165 15.3333H5.4165C3.1665 15.3333 1.6665 14.2083 1.6665 11.5833V7.08325C1.6665 4.45825 3.1665 3.33325 5.4165 3.33325H7.6665C7.55817 3.64992 7.49984 3.99992 7.49984 4.37492V7.62494C7.49984 8.43327 7.7665 9.11659 8.2415 9.59159C8.7165 10.0666 9.39984 10.3333 10.2082 10.3333V11.4916C10.2082 11.9166 10.6915 12.1749 11.0498 11.9415L13.4582 10.3333H15.6248C15.9998 10.3333 16.3498 10.2749 16.6665 10.1665Z",
    fill: "white",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.37508V7.6251C18.3333 8.86677 17.7 9.80004 16.6667 10.1667C16.35 10.275 16 10.3334 15.625 10.3334H13.4583L11.05 11.9417C10.6917 12.175 10.2083 11.9168 10.2083 11.4918V10.3334C9.4 10.3334 8.71667 10.0668 8.24167 9.59176C7.76667 9.11676 7.5 8.43343 7.5 7.6251V4.37508C7.5 4.00008 7.55833 3.65008 7.66667 3.33341C8.03333 2.30008 8.96667 1.66675 10.2083 1.66675H15.625C17.25 1.66675 18.3333 2.75008 18.3333 4.37508Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16699 18.3333H12.167",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 15.3333V18.3332",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4129 6.04167H15.4204",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0799 6.04167H13.0874",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7464 6.04167H10.7539",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushNotificationsIcon);
export default __webpack_public_path__ + "static/media/push-notifications-icon.269e68ccf50cff6eef5c5399824a2ccd.svg";
export { ForwardRef as ReactComponent };